import { Typography } from "@mui/material";

type KeyFrameMessageProps = {
  message: string;
  height?: string;
};

const KeyFrameMessage: React.FC<KeyFrameMessageProps> = ({
  message,
  height = "100%",
}): JSX.Element => {
  return (
    <Typography
      component="div"
      variant="body2Bold"
      textAlign="center"
      color="otherTextTertiary.main"
      sx={{
        width: "100%",
        height: height,
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        textWrap: "wrap",
      }}
    >
      {message}
    </Typography>
  );
};

export default KeyFrameMessage;
